import { render, staticRenderFns } from "./TopicCreate.vue?vue&type=template&id=10575892&scoped=true&"
import script from "./TopicCreate.vue?vue&type=script&lang=js&"
export * from "./TopicCreate.vue?vue&type=script&lang=js&"
import style0 from "./TopicCreate.vue?vue&type=style&index=0&id=10575892&lang=less&scoped=true&"
import style1 from "./TopicCreate.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10575892",
  null
  
)

export default component.exports